module.exports = __webpack_public_path__ + "static/media/land-scanner-banner-img-mobile.1fcf0f8b.jpg";